import { Box, Divider, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { BlogPost } from 'src/logic/models/blog';
import { parseHtmlWithAnchors } from './parserUtility';

type IProps = {
  post: BlogPost;
};

const BlogPostPageContent = ({ post }: IProps) => {
  const { content, headings } = parseHtmlWithAnchors(post.body);

  return (
    <div className='page'>
      <Box
        py={8}
        style={{
          backgroundImage: `url("${post.cover_photo_path}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#fff',
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', zIndex: 1, inset: 0, background: 'rgba(0, 0, 0, 0.35)' }}></div>
        <div
          className='page__content'
          style={{
            position: 'relative',
            zIndex: 2,
            minHeight: '50vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            color='#fff'
            fontWeight={600}
            fontSize={{ xs: 32, lg: 48 }}
            lineHeight={1.1}
            component='h1'
            maxWidth={'680px'}
          >
            {post.title}
          </Typography>
          {post.sub_title ? (
            <Typography
              color='#fff'
              mt={3}
              fontWeight={400}
              fontSize={{ xs: 14, lg: 18 }}
              lineHeight={1.25}
              component='p'
              maxWidth={'680px'}
              sx={{ opacity: 0.9 }}
            >
              {post.sub_title}
            </Typography>
          ) : null}
        </div>
      </Box>

      <div className='page__content'>
        <Grid container py={5} width={'100%'}>
          <Grid item pb={3} xs={12} sm={12} md={8} lg={8} xl={8}>
            <Box
              sx={{
                '*': {
                  maxWidth: '100%',
                },
                img: {
                  objectFit: 'contain',
                  height: 'auto',
                },
                '& p': {
                  marginBlock: 0.5,
                },
                '& h1, & h2, & h3, & h4, & h5, & h6': {
                  marginBottom: 0.75,
                },
              }}
            >
              <article>{content}</article>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
            sx={{
              pl: {
                xs: 0,
                md: 5,
              },
            }}
          >
            <Box p={2} component={'aside'}>
              {headings.length > 0 && (
                <>
                  <Typography
                    mb={2}
                    color='#00385E'
                    fontWeight={600}
                    fontSize={{ xs: 16, lg: 20 }}
                    lineHeight={1.1}
                    component='h3'
                  >
                    Key Points
                  </Typography>
                  <ul style={{ paddingInlineStart: '1em' }}>
                    {headings.map(h => (
                      <Typography
                        key={h.id}
                        my={1}
                        color={'#000'}
                        fontWeight={600}
                        fontSize={{ xs: 10, lg: 12 }}
                        lineHeight={1.3}
                        component={'li'}
                      >
                        <a href={`#${h.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                          {h.text}
                        </a>
                      </Typography>
                    ))}
                  </ul>
                  <Divider sx={{ my: 2.5 }} />
                </>
              )}

              {post.tags && post.tags.length > 0 && (
                <>
                  <Typography
                    mb={1}
                    color='#00385E'
                    fontWeight={600}
                    fontSize={{ xs: 16, lg: 20 }}
                    lineHeight={1.1}
                    component='h3'
                  >
                    Popular Tags
                  </Typography>
                  <Box display={'flex'} gap={1} flexWrap={'wrap'}>
                    {post.tags.map(tag => (
                      <Typography
                        key={tag.id}
                        fontSize={{
                          xs: 8,
                          lg: 11,
                        }}
                        fontWeight={700}
                        color='#fff'
                        sx={{
                          backgroundColor: '#0F5D85',
                          borderRadius: '30px',
                          display: 'inline-block',
                          letterSpacing: '1px',
                          py: 0.5,
                          px: 1,
                        }}
                      >
                        {tag.name}
                      </Typography>
                    ))}
                  </Box>
                  <Divider sx={{ my: 2.5 }} />
                </>
              )}

              <Typography color='#00385E' fontWeight={400} fontSize={{ xs: 11, lg: 14 }} lineHeight={1.1}>
                Published on: <strong>{moment(post.published_at, 'DD-MM-YYYY').format('ll')}</strong>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default BlogPostPageContent;
